<template>
  <div>
    <form-field-select
      label="Status"
      v-model="form.status"
      :validation-errors="validationErrors.status"
    >
      <option
        v-for="status in statuses"
        :key="status.value"
        :value="status.value"
      >{{ status.label }}</option>
    </form-field-select>

    <form-field-currency
      label="Sale Amount"
      v-model="form.sale_amount"
      :validation-errors="validationErrors.sale_amount"
    />

    <form-field-currency
      label="Joint Venture Costs"
      v-model="form.joint_venture_costs"
      :validation-errors="validationErrors.joint_venture_costs"
    />

    <form-field-currency
      label="Closing Costs"
      v-model="form.closing_costs"
      :validation-errors="validationErrors.closing_costs"
    />

    <form-field-currency
      label="Realtor Commissions"
      v-model="form.realtor_commissions"
      :validation-errors="validationErrors.realtor_commissions"
    />

    <form-field-currency
      label="Marketing Costs"
      v-model="form.marketing_costs"
      :validation-errors="validationErrors.marketing_costs"
    />

    <form-field-currency
      label="Carrying Costs"
      v-model="form.carrying_costs"
      :validation-errors="validationErrors.carrying_costs"
    />

    <form-field-currency
      label="Buyer Concessions"
      v-model="form.buyer_concessions"
      :validation-errors="validationErrors.buyer_concessions"
    />

    <form-field-currency
      label="Miscellaneous Fees"
      v-model="form.miscellaneous_fees"
      :validation-errors="validationErrors.miscellaneous_fees"
    />

    <form-field-date-picker
      label="Accepted At"
      v-model="form.accepted_at"
      :validation-errors="validationErrors.accepted_at"
      is-inline
      has-clear-button
    />

    <form-field-date-picker
      label="Contracted At"
      v-model="form.contracted_at"
      :validation-errors="validationErrors.contracted_at"
      is-inline
      has-clear-button
    />

    <form-field-date-picker
      label="Closing At"
      v-model="form.closing_at"
      :validation-errors="validationErrors.closing_at"
      is-inline
      has-clear-button
    />
  </div>
</template>

<script>
  import {FormMixin} from "./forms.mixin";
  import {ENUMS} from "../services/enums";

  export default {
    name: "FlipSellingInfoForm",
    props: ['formData'],
    mixins: [FormMixin],
    data() {
      return {
        form: {},
        validationErrors: {},
        defaultForm: {
          market_id: '',
          record_id: '',
          sale_amount: '',
          joint_venture_costs: '',
          closing_costs: '',
          realtor_commissions: '',
          marketing_costs: '',
          carrying_costs: '',
          buyer_concessions: '',
          miscellaneous_fees: '',
          status: '',
          accepted_at: '',
          contracted_at: '',
          closing_at: '',
        },
      }
    },
    created() {
      // This allows you to pass in formData without an id in order to add data to the defaultForm for the the create
      this.form = (this.formData && this.formData.id) ? this.$utils.clone(this.formData) : this.$utils.clone({...this.defaultForm, ...this.formData});
    },
    computed: {
      statuses() {
        return ENUMS.FixAndFlipSellingInfoStatusEnum;
      }
    },
    methods: {
      update() {
        return this.$api.fixAndFlipSellingInfos.update(this.form)
          .then(res => {
            this.$buefy.toast.open({
              message: 'Fix and Flip Selling Info was updated',
              type: 'is-success'
            });

            return res;
          })
        },
      create() {
        return this.$api.fixAndFlipSellingInfos.create(this.form)
          .then(res => {
            this.$buefy.toast.open({
              message: 'Fix and Flip Selling Info was created',
              type: 'is-success'
            });

            return res;
          })
        },
      delete() {
        return this.$api.fixAndFlipSellingInfos.delete(this.form.id)
          .then(res => {
            this.$buefy.toast.open({
              message: 'Fix and Flip Selling Info was archived',
              type: 'is-success'
            });

            return res;
          });
      },
      restore() {
        return this.$api.fixAndFlipSellingInfos.restore(this.form.id)
          .then(res => {
            this.$buefy.toast.open({
              message: 'FixAndFlipSellingInfo was restored',
              type: 'is-success'
            });

            return res;
          });
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>
